export default __webpack_public_path__ + "static/media/product9.2b73ae74.jpg";